import {
  FilePart,
  ImagePart,
  TextPart,
  ToolCallPart,
  ToolResultPart,
} from "ai";
import { z } from "zod";

export const textPartSchema = z.object({
  type: z.literal("text"),
  text: z.string(),
}) satisfies z.ZodType<TextPart>;

export const filePartSchema = z.object({
  type: z.literal("file"),
  data: z.string(),
  //Unserializable data error for rpc if we have array buffer
  // data: z.union([
  //   z.string(),
  //   z.instanceof(ArrayBuffer),
  //   z.instanceof(Uint8Array),
  // ]),
  filename: z.string().optional(),
  mimeType: z.string(),
}) satisfies z.ZodType<FilePart>;

export const imagePartSchema = z.object({
  type: z.literal("image"),
  image: z.string(),
  //Unserializable data error for rpc if we have array buffer
  // image: z.union([
  //   z.string(),
  //   z.instanceof(ArrayBuffer),
  //   z.instanceof(Uint8Array),
  // ]),
  mimeType: z.string(),
}) satisfies z.ZodType<ImagePart>;

export const toolCallPartSchema = z.object({
  type: z.literal("tool-call"),
  toolCallId: z.string(),
  toolName: z.string(),
  args: z.record(z.any()),
}) satisfies z.ZodType<ToolCallPart>;

export type ToolCallPartType = z.infer<typeof toolCallPartSchema>;

export const toolResultPartSchema = z.object({
  type: z.literal("tool-result"),
  toolCallId: z.string(),
  toolName: z.string(),
  result: z.record(z.any()),
}) satisfies z.ZodType<ToolResultPart>;

export type ToolResultPartType = z.infer<typeof toolResultPartSchema>;
